
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/accounts",
      function () {
        return require("private-next-pages/settings/accounts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/accounts"])
      });
    }
  